import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const applyChangeCity = async (params: object) => {
  return await POST({ url: Api.applyChangeCity, params, showError: false })
}
export const itemCheckV2 = async (params: object) => {
  return await GET({ url: Api.itemCheckV2, params, showError: false })
}
export const enable = async (params: object) => {
  return await GET({ url: Api.enable, params, showError: true })
}
export const activationScoreEnable = async (params: object) => {
  return await GET({ url: Api.activationScoreEnable, params, showError: false })
}
export const changeCityLimit = async (params: object) => {
  return await GET({ url: Api.changeCityLimit, params, showError: false })
}
export const status = async (params: object) => {
  return await GET({ url: Api.status, params, showError: false })
}
